<template>
    <div class="stale-accounts-wrapper">
        <Table :columns="columns" :loading="dataLoading"  width="800" :data="staleAccounts">
            <div slot-scope="{ row }" slot="mailAddress">
                <strong>{{ row.mailAddress }}</strong>
            </div>
            <div slot-scope="{ row }" slot="action">
                <Button type="error" size="small" @click="remove(row)">Delete</Button>
            </div>
        </Table>
        <Button type="error" @click="remove('all')" class="remove-all" v-if="staleAccounts.length>1">Delete All</Button>
    </div>
</template>

<script>
    import {bus} from "../../main";
    import { getFamilies, deleteFamily } from '../../_services/family.service'
    export default {
        data() {
            return {
                columns: [
                    {
                        title: 'STALE ACCOUNTS',
                        align: 'left',
                        className: 'table-heading',
                        children: [
                            {
                                title: "Email",
                                slot: "mailAddress"
                            },
                            {
                                title: "Parental Code ",
                                key: "parentalCode"
                            },
                            {
                                title: " ",
                                slot: "action",
                                width: 220,
                                align: "right"
                            }
                        ]
                    }
                ],
                staleAccounts: [],
                dataLoading:true
            };
        },
        methods: {
            getStaleAccountsList() {
                getFamilies({ValidMail:false, Days:3}).then(res=>{
                    this.staleAccounts = res.data.data;
                    this.dataLoading = false
                }).catch(err => {
                    this.dataLoading = false
                    bus.$emit('requestError',err)
                    this.$Message.error("Failed to get Stale Accounts. Please try again later.");
                });
            },
            remove(data){
                let vm=this
                if(data==='all') {
                    this.$Modal.confirm({
                        title: 'Remove Family',
                        content: `<p>Are you sure you want to remove all accounts?</p>`,
                        okText: 'Remove',
                        cancelText: 'Cancel',
                        onOk: () => {
                            this.dataLoading = true
                            vm.staleAccounts.forEach(function (account, index) {
                                deleteFamily(account.id).then(res => {
                                    if(index+1===vm.staleAccounts.length){
                                        vm.dataLoading = false
                                        vm.$Message.success(`Successfully deleted all stale accounts!`);
                                    }
                                }).catch(err => {
                                    if(index+1===vm.staleAccounts.length){
                                        vm.dataLoading = false
                                        vm.$Message.error("Failed to remove accounts. Please try again later.");
                                    }
                                });
                            })
                        },
                    });
                }else{
                    this.$Modal.confirm({
                        title: 'Remove Family',
                        content: `<p>Are you sure you want to remove ${data.mailAddress}?</p>`,
                        okText: 'Remove',
                        cancelText: 'Cancel',
                        onOk: () => {
                            this.dataLoading = true
                            deleteFamily(data.id).then(res => {
                                this.getStaleAccountsList();
                                this.dataLoading = false
                                this.$Message.success(`Account ${data.mailAddress}  successfully deleted!`);
                            }).catch(err => {
                                this.dataLoading = false
                                this.$Message.error("Failed to remove account. Please try again later.");
                            });
                        },
                    });
                }
            }
        },
        mounted() {
            this.getStaleAccountsList();
        }
    };
</script>
<style scoped>
    .stale-accounts-wrapper{
        width: 800px;
    }
    .remove-all{
        margin-top: 20px;
        float: right;
    }
</style>
